import { tx } from "../../lib/i18n";
import { useSearchParams } from "react-router-dom";

export const useTab = (def) => {
  const [p, setP] = useSearchParams();
  return [p.get("tab") || def, (t) => setP({ tab: t })];
};

export const DashShell = ({ title, sub, tabs, tab, setTab, children, testid }) => (
  <div className="bg-[#F7FAFE] pb-10" data-testid={testid}>
    <div className="osk-container pt-8">
      <h1 className="text-3xl md:text-4xl">{tx(title)}</h1>
      {sub && <p className="mt-1 text-sm text-osk-text">{tx(sub)}</p>}
      <div className="no-scrollbar -mx-5 mt-6 flex gap-2 overflow-x-auto px-5 pb-1 md:mx-0 md:flex-wrap md:px-0">
        {tabs.map(([key, label, Icon]) => (
          <button key={key} onClick={() => setTab(key)} data-testid={`tab-${key}`}
            className={`flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-bold transition-colors ${tab === key ? "bg-osk-blue text-white shadow" : "bg-white text-osk-navy hover:bg-osk-light"}`}>
            {Icon && <Icon className="h-4 w-4" />}{tx(label)}
          </button>
        ))}
      </div>
      <div className="osk-rise mt-6" key={tab}>{children}</div>
    </div>
  </div>
);

export const Stat = ({ label, value, icon: Icon, testid }) => (
  <div className="osk-card p-5" data-testid={testid}>
    <div className="flex items-center justify-between"><p className="text-sm text-osk-muted">{tx(label)}</p>{Icon && <Icon className="h-5 w-5 text-osk-blue" />}</div>
    <p className="mt-2 text-2xl font-extrabold text-osk-navy">{value}</p>
  </div>
);

const STATUS = {
  paid: ["Betaald", "bg-tile-mint text-emerald-700"], held: ["Wacht op betaling", "bg-tile-yellow text-amber-700"],
  awaiting_payment: ["Betaallink verstuurd", "bg-tile-yellow text-amber-700"], released: ["Vrijgegeven", "bg-slate-100 text-slate-600"],
  cancelled: ["Geannuleerd", "bg-tile-red text-osk-red"], scheduled: ["Gepland", "bg-tile-blue text-osk-blue"], held_session: ["Gegeven", "bg-tile-mint text-emerald-700"],
  teacher_no_show: ["Docent no-show", "bg-tile-red text-osk-red"], succeeded: ["Geslaagd", "bg-tile-mint text-emerald-700"], failed: ["Mislukt", "bg-tile-red text-osk-red"],
  pending: ["In behandeling", "bg-tile-yellow text-amber-700"], approved: ["Goedgekeurd", "bg-tile-mint text-emerald-700"], rejected: ["Afgewezen", "bg-tile-red text-osk-red"],
  active: ["Actief", "bg-tile-mint text-emerald-700"], archived: ["Gearchiveerd", "bg-slate-100 text-slate-600"],
};

export const Badge = ({ status, session }) => {
  const [label, cls] = STATUS[session && status === "held" ? "held_session" : status] || [status, "bg-slate-100 text-slate-600"];
  return <span className={`osk-pill ${cls}`} data-testid={`status-${status}`}>{tx(label)}</span>;
};

export const Table = ({ cols, rows, empty = "Nog niets om te tonen.", testid }) => (
  <div className="osk-card overflow-x-auto" data-testid={testid}>
    <table className="w-full min-w-[640px] text-left text-sm">
      <thead><tr className="border-b border-slate-100 text-xs uppercase tracking-wider text-osk-muted">{cols.map((c) => <th key={c.label} className="px-4 py-3 font-semibold">{tx(c.label)}</th>)}</tr></thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.id || i} className="border-b border-slate-50 last:border-0 hover:bg-[#F7FAFE]">
            {cols.map((c) => <td key={c.label} className="px-4 py-3 align-top">{c.render ? c.render(r) : r[c.key]}</td>)}
          </tr>
        ))}
        {!rows.length && <tr><td colSpan={cols.length} className="px-4 py-10 text-center text-osk-muted">{tx(empty)}</td></tr>}
      </tbody>
    </table>
  </div>
);

export const Section = ({ title, action, children }) => (
  <section className="mb-8">
    <div className="mb-3 flex items-center justify-between gap-3"><h2 className="text-xl">{tx(title)}</h2>{action}</div>
    {children}
  </section>
);
